import { useCheckGuestAccess } from '../feature-usage/useCheckGuestAccess';
import { useCheckPageInsights } from '../feature-usage/useCheckPageInsights';
import { useCheckPageRestrictions } from '../feature-usage/useCheckPageRestrictions';
import { useGetNumberOfUsers } from '../feature-usage/useGetNumberOfUsers';

export const useLoadFeatureUsageToStore = () => {
	useCheckGuestAccess();
	useCheckPageInsights();
	useCheckPageRestrictions();
	useGetNumberOfUsers();
};
